import { useLocales, useThemeContext } from 'src/contexts'

import { getColorDictionary } from 'src/features/ColorThemeSelect/helpers'

export const useColorThemeSelect = () => {
  const { translations } = useLocales()
  const { colorTheme, handleSetColorTheme } = useThemeContext()

  return {
    locale: translations.setting.colorTheme,
    options: getColorDictionary(translations.setting.colorTheme),
    colorTheme,
    handleSetColorTheme,
  }
}
